class SearchBar {
  constructor(node) {
    this.rootElement = node;
    this.buttonElement = this.rootElement.querySelector('.c-search-bar__icon');
    this.searchElement = this.buttonElement.closest('.c-search-bar').querySelector('.c-search-bar__input');
    this.labelElement = this.searchElement.closest('.js-search');
    this.searchElement.addEventListener('keypress', this.onKeyPress.bind(this));
    this.buttonElement.addEventListener('click', this.onClick.bind(this));
    if (this.labelElement) {
      this.labelElement.addEventListener('click', this.activateSearch.bind(this));
      this.searchElement.addEventListener('blur', this.deactivateSearch.bind(this));
    }
  }

  onKeyPress() {
    if (this.searchElement.value !== '') {
      this.buttonElement.classList.remove('is-hidden');
    } else {
      this.buttonElement.classList.add('is-hidden');
    }
  }

  onClick() {
    this.searchElement.value = '';

    if (this.searchElement.value === '') {
      this.buttonElement.classList.add('is-hidden');
    }
  }

  activateSearch() {
      if (this.searchElement.classList.contains('is-hidden')) {
        this.searchElement.classList.remove('is-hidden');
        this.rootElement.classList.add('is-open');
      }
  }

  deactivateSearch() {
    if (!this.searchElement.classList.contains('is-hidden') && !this.searchElement.value) {
      this.searchElement.classList.add('is-hidden');
      this.rootElement.classList.remove('is-open');
    }
  }
}

const searchBars = document.querySelectorAll('.c-search-bar');
searchBars.forEach((searchBar) => {
  new SearchBar(searchBar);
});
